.tabCard {
    border: 1px solid var(--exo-color-border-secondary);
    border-radius: 12px;
    overflow: hidden;
    padding: var(--exo-spacing-x-small);
}

.tabs {
    display: block;

    &::after {
        display: block;
        content: '';
        margin: 0 calc(-1 * var(--exo-spacing-x-small));
        border-bottom: 1px solid var(--exo-color-border-secondary);
    }
}

.tabContent {
    padding: var(--exo-spacing-large) var(--exo-spacing-small);
    display: flex;
    flex-direction: column;
    gap: var(--exo-spacing-large);
}

.tabBadge::part(badge) {
    font-weight: var(--exo-font-weight-semi-bold);
    color: var(--exo-color-border-tertiary);
}

.hidden {
    display: none;
}

.detailsContent {
    display: flex;
    flex-direction: column;
    gap: var(--exo-spacing-large);
}

.section {
    display: flex;
    flex-direction: column;
    gap: var(--exo-spacing-x-small);
}

.sectionLabel {
    font: var(--exo-text-body-medium);
    color: var(--exo-color-font);
}

.authCard {
    border: 1px solid var(--exo-color-border-secondary);
    border-radius: 8px;
    background: var(--exo-color-background-secondary);
    padding: var(--exo-spacing-standard);
    display: flex;
    flex-direction: column;
    gap: var(--exo-spacing-standard);
}

.suppliedAuthMessage {
    font-size: var(--exo-font-size-x-small);
    color: var(--exo-color-font-secondary);
}
